/* eslint-disable no-console */
import { datadogLogs } from '@datadog/browser-logs';

export const dataDogInit = () => {
	if (import.meta.env.VITE_ENV === 'production') {
		datadogLogs.init({
			clientToken: 'pubf4d4c075b89d3c162415ec98ed6ba148',
			site: 'datadoghq.com',
			service: 'companies',
			forwardErrorsToLogs: true,
			sampleRate: 100,
			env: 'production',
		});
		console.warn(
			'%c DATADOG LOG INITIATE! ',
			'background: #8dc63f; color: #fff',
		);
	} else {
		console.warn(
			'%c DATADOG NOT INITIATE! ',
			'background: #bf3434; color: #fff',
		);
	}
};
